import { useQuery } from '@hooks/reactQuery';

import { getUserGroups } from '@api/common';

import { IRolesResponse } from '@interfaces/user/user';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { TUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { USER_GROUP } from '@constants/queryKeys';

export const useQueryUserGroups = () => {
	const {
		data: roles,
		isLoading: isLoadingRoles,
	} = useQuery<Array<IRolesResponse>, TSelectOptionType<TUserRoles>[]>({
		queryKey: [USER_GROUP],
		queryFn: getUserGroups,
		select: (roles) => {
			return roles?.map((item) => ({
				...item,
				value: item.name,
				label: item.title,
			}));
		},
		...refetchOptions,
	});

	return {
		rolesOptions: roles || [],
		isLoadingRoles,
	};
};
